import React from 'react';
import Modal from '../../../ui/modal/modal';
import Button, { ButtonGroup } from '../../../ui/button/button';
import CropImage from '../../crop-image/cropImage';
import { useTranslation } from 'react-i18next';
import { UploadTrigger } from '../uploadInput';
import './modalEditImage.css';

let imageUrl = '';

export default function ModalEditImage({
    isOpen = false,
    subtitle = null,
    isSubmitting = false,
    ratio = null,
    forceRatio = false,
    minWidth = 180,
    maxWidth = Infinity,
    minHeight = 180,
    maxHeight = Infinity,
    onClose = () => {},
    onCancel = () => {},
    imageFile = null,
    onSubmit = () => {},
    onSelectFile = () => {},
    maxSize = 5242880,
    fileErrors = [],
    acceptedMimeTypes = [],
    isUploading = false ,
    uniqueKey
}) {
    const { t } = useTranslation();

    const [imageCroppedFile, setImageCroppedFile] = React.useState(null);

    const imgSrc = React.useMemo(() => {
        if (imageUrl) {
            URL.revokeObjectURL(imageUrl);
        }
        if (imageFile) {
            imageUrl = URL.createObjectURL(imageFile);
            return imageUrl;
        }

        return null;
    }, [imageFile]);

    const _onSubmit = React.useCallback(() => {
        onSubmit(imageCroppedFile);
    }, [onSubmit, imageCroppedFile]);

    const _onChangeCrop = React.useCallback((blobUrl, file) => {
        setImageCroppedFile(file);
    }, []);

    return (
        <Modal
            id={`edit_image_${uniqueKey}`}
            open={isOpen}
            onClose={onClose}
            title={t('widget.input.crop-modal.title')}
            subtitle={subtitle}
            customFooter={
                <ButtonGroup className='modal-edit-button-group'>
                    <Button
                        tabIndex="0"
                        type='inverted-secondary'
                        onClick={onClose}
                        disabled={isSubmitting} label={t('widget.input.crop-modal.cta-cancel')} />
                    <UploadTrigger
                        onFileSelected={onSelectFile}
                        acceptedMimeTypes={acceptedMimeTypes}
                        disabled={isSubmitting}
                        maxSize={maxSize}
                        label={t('widget.input.crop-modal.replace')}
                        isUploading={isUploading}
                        uniqueKey={`${uniqueKey}_crop`}
                    />
                    <Button
                        tabIndex="0"
                        disabled={!imageCroppedFile || fileErrors.length > 0}
                        isLoading={isSubmitting}
                        type='primary'
                        onClick={_onSubmit}
                        onKeyDown={(e) => {if (e.key === "Tab" && !e.shiftKey) e.preventDefault()}}
                        label={t('widget.input.crop-modal.cta-save')}
                    />
                </ButtonGroup>
            }
        >
            {fileErrors.map(error => {
                return (
                    <div className={'modal-edit-image__file-error'} key={error}>
                        {error}
                    </div>
                );
            })}
            <CropImage
                key={imgSrc}
                imgSrc={imgSrc}
                imgTypeMime={imageFile?.type}
                onChange={_onChangeCrop}
                ratio={ratio}
                forceRatio={forceRatio}
                minWidth={minWidth}
                maxWidth={maxWidth}
                minHeight={minHeight}
                maxHeight={maxHeight}
                labelRatio={t('widget.input.crop-modal.ratio')}
                labelWidth={t('widget.input.crop-modal.width')}
                labelHeight={t('widget.input.crop-modal.height')}
                labelActions={t('widget.input.crop-modal.actions')}
            />
        </Modal>
    );
}
